<template>
  <el-dialog title="确认提示" :visible.sync="dialogVisible" width="25%" :show-close= false :close-on-click-modal= false>
    <div class="tip">
      <div>请提醒用户签署《门禁授权申请表》</div>
      <div><el-checkbox v-model="remind">7天内不再提醒</el-checkbox></div>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button><a :href="url">表格下载</a></el-button>
      <el-button type="primary" @click="changeState">确 定</el-button>
    </span>
  </el-dialog>
</template>
<script>
import cookie from '../../utils/Tools/index'
export default {
  data () {
    return {
      dialogVisible: false,
      remind: false,
      url: ''
    }
  },
  created () {
    this.remind = false
  },
  watch: {
    '$store.getters.dialogVisible' (newVal) {
      if (newVal) {
        this.dialogVisible = true
        this.down()
      }
    },
    '$store.getters.remind' (newVal) {
      this.remind = newVal
    },
    remind (newVal) {
      if (newVal) {
        this.$store.commit('changeRemind', true)
        if (this.$store.getters.pageName === 'addressBookPage') {
          cookie.setCookie('showTip', true, 7)
        } else if (this.$store.getters.pageName === 'showVisitorInvitedPage') {
          cookie.setCookie('showVisitorInvitedTip', true, 7)
        } else if (this.$store.getters.pageName === 'showVisitorRegistorPage') {
          cookie.setCookie('showVisitorRegistorTip', true, 7)
        } else if (this.$store.getters.pageName === 'showVisitorManagerPage') {
          cookie.setCookie('showVisitorManagerTip', true, 7)
        } else {
          // sonar规则校验语法必须else
        }
      } else {
        this.$store.commit('changeRemind', false)
        if (this.$store.getters.pageName === 'addressBookPage') {
          cookie.setCookie('showTip', true, -1)
        } else if (this.$store.getters.pageName === 'showVisitorInvitedPage') {
          cookie.setCookie('showVisitorInvitedTip', true, -1)
        } else if (this.$store.getters.pageName === 'showVisitorRegistorPage') {
          cookie.setCookie('showVisitorRegistorTip', true, -1)
        } else if (this.$store.getters.pageName === 'showVisitorManagerPage') {
          cookie.setCookie('showVisitorManagerTip', true, -1)
        } else {
          // sonar规则校验语法必须else
        }
      }
    }
  },
  methods: {
    changeState () {
      this.dialogVisible = false
      this.$store.commit('changeIsTrue', true) // 点击确认按钮  changeIsTrue 干嘛的
      this.$store.commit('changeDialogVisible', false) // 协议框关闭
      this.$store.commit('changeIsShow', true) // 通讯录打开
    },
    async down () {
      this.url = 'https://peoplego.oss-cn-shenzhen.aliyuncs.com/ryx/%E6%B1%87%E6%8A%A5-%E9%97%A8%E7%A6%81%E6%8E%88%E6%9D%83%E7%94%B3%E8%AF%B7%E8%A1%A82021_0326.docx'
      // const res = await this.$https.axios({
      //   method: 'get',
      //   url: 'file/template/authApplication'
      // })
      // if (res.code === 'RESP0000') {
      //   this.url = res.data
      // } else {
      //   this.url = ''
      // }
    }
  }
}
</script>
<style scoped lang="less">
.tip{
  font-size: 16px;
  margin-right: 25%;
  >div{
    text-align: right;
    line-height: 30px;
  }
}
.dialog-footer{
  a{
    color: #606266;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/public/confirmDialog.vue